// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1Ym0Q","content":"GlobalSearch_content__5puo5"};